import React, { useEffect, useRef, useState } from "react";
import { SearchFormContainer } from "../styled/header";
import { CiSearch } from "react-icons/ci";
import { AiOutlineClose } from "react-icons/ai";
import moment from "moment";
import useOutsideClick from "../../../../../hooks/useOutsideClick";
import { useNavigate, useParams } from "react-router";
import { useSearchParams } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { GrPrevious } from "react-icons/gr";

const Recent = ({ keywords, onRemove, onClear, onClickKeyword }) => {
  const isMobile = useMediaQuery({ query: "(max-width:767px)" });

  return (
    <div className="recent">
      <div className="tit">
        <span>최근 검색어</span>
        {keywords && keywords.length > 0 && <button onClick={onClear}>전체 삭제</button>}
      </div>
      <ul>
        {(keywords || []).slice(0, isMobile ? 3 : 10).map((word, i) => (
          <li key={i}>
            <span onClick={() => onClickKeyword(word.keyword)}>
              <i>
                <CiSearch />
              </i>
              {word.keyword}
            </span>
            <div>
              <span>{moment(word.date).format("YYYY.MM.DD")}</span>
              <button onClick={() => onRemove(i)}>
                <AiOutlineClose />
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

const Popular = () => {
  return (
    <div className="popular">
      <div className="tit">
        <span>실시간 인기상품</span>
        <span>{moment().format("YYYY년 MM월 DD일 HH시")} 업데이트</span>
      </div>
      <ul>
        {Array.from({ length: 10 }).map((_, idx) => (
          <li key={idx}>
            <span>{idx + 1}</span>
            <span>인기상품 {idx + 1}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

const SearchForm = ({ toggleSearch, setToggleSearch }) => {
  const navigate = useNavigate();

  const isMobile = useMediaQuery({ query: "(max-width:767px)" });

  const { url } = useParams();
  const [searchParams] = useSearchParams();
  const queryKeyword = searchParams.get("keyword") || "";

  const [searched, setSearched] = useState(queryKeyword);
  const [keywords, setKeywords] = useState(() => {
    const stored = localStorage.getItem("recentKeywords");
    return stored ? JSON.parse(stored) : [];
  });

  const searchRef = useRef();
  const inputRef = useRef();

  useOutsideClick(searchRef, () => {
    setToggleSearch(false);
  });

  useEffect(() => {
    toggleSearch && inputRef.current && inputRef.current.focus();
  }, [toggleSearch]);

  // 로컬스토리지 저장
  const saveKeywords = (newList) => {
    setKeywords(newList);
    localStorage.setItem("recentKeywords", JSON.stringify(newList));
  };

  // 검색
  const handleSearch = () => {
    const trimmed = searched.trim();
    if (!trimmed) return;

    const newItem = {
      keyword: trimmed,
      date: new Date(),
    };

    const filtered = keywords.filter((k) => k.keyword !== trimmed);
    const newList = [newItem, ...filtered].slice(0, 10);
    saveKeywords(newList);
    setSearched("");

    navigate(`/shop${url ? `/${url}` : ""}/search?keyword=${searched}`);
    setToggleSearch(false);
  };

  // 삭제
  const handleRemove = (index) => {
    const newList = keywords.filter((_, i) => i !== index);
    saveKeywords(newList);
  };

  // 전체삭제
  const handleClear = () => {
    saveKeywords([]);
  };

  // 최근 검색어 클릭
  const handleKeywordClick = (keyword) => {
    const newItem = {
      keyword,
      date: new Date(),
    };

    const filtered = keywords.filter((k) => k.keyword !== keyword);
    const newList = [newItem, ...filtered].slice(0, 10);
    saveKeywords(newList);

    navigate(`/shop${url ? `/${url}` : ""}/search?keyword=${keyword}`);
    setToggleSearch(false);
  };

  return (
    <SearchFormContainer className={toggleSearch ? "active" : "inactive"} ref={searchRef}>
      <div>
        <div className="form">
          <input
            ref={inputRef}
            type="text"
            placeholder="검색어를 입력해주세요"
            value={searched}
            onChange={(e) => setSearched(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleEnterKey(e, handleSearch);
              }
            }}
          />
          <button onClick={handleSearch}>
            <CiSearch />
          </button>
        </div>
        <button onClick={() => setToggleSearch(false)}>
          {isMobile ? <GrPrevious /> : <AiOutlineClose />}
        </button>
      </div>
      <div>
        <Recent
          keywords={keywords}
          onRemove={handleRemove}
          onClear={handleClear}
          onClickKeyword={handleKeywordClick}
        />
        <Popular />
      </div>
    </SearchFormContainer>
  );
};

export default SearchForm;
